namespace GeniuzPOS.QRreport {
    export interface QRyreportRow {
        Id?: number;
        ReportId?: string;
        ReportName?: string;
        UrlReport?: string;
        DataStructureName?: string;
        QrViewName?: string;
        CreateBy?: string;
        CreateDate?: string;
        FullName?: string;
        QRSubViewName?: string;
        QRFunctionsGroupby_A?: string;
        QRFunctionsLength_B?: string;
        RemarkNote?: string;
    }

    export namespace QRyreportRow {
        export const idProperty = 'ReportId';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'QRreport.QRyreport';
        export const lookupKey = 'QRreport.QRyreport';

        export function getLookup(): Q.Lookup<QRyreportRow> {
            return Q.getLookup<QRyreportRow>('QRreport.QRyreport');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            ReportId = "ReportId",
            ReportName = "ReportName",
            UrlReport = "UrlReport",
            DataStructureName = "DataStructureName",
            QrViewName = "QrViewName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            FullName = "FullName",
            QRSubViewName = "QRSubViewName",
            QRFunctionsGroupby_A = "QRFunctionsGroupby_A",
            QRFunctionsLength_B = "QRFunctionsLength_B",
            RemarkNote = "RemarkNote"
        }
    }
}
